<template>
    <LoginModal />
    <RegistrationModal />
    <NotificationPopup />
</template>

<script setup lang="ts">
import LoginModal from "./components/login-modal.vue";
import RegistrationModal from "./components/registration-modal.vue";
import NotificationPopup from "./components/account-notification.vue";

defineEmits(["loader"]); // console.log warning issue
</script>
